<template>
    <div>
        <h1>Hello World.</h1>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "dashboard"
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?3f9de38a